export const RedispatchIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="24" fill="currentColor" fillOpacity="0.1" />
    <path
      d="M32 20L28 16M28 16L32 12M28 16H32C33.0609 16 34.0783 16.4214 34.8284 17.1716C35.5786 17.9217 36 18.9391 36 20C36 21.0609 35.5786 22.0783 34.8284 22.8284C34.0783 23.5786 33.0609 24 32 24H16"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 28L20 32M20 32L16 36M20 32H16C14.9391 32 13.9217 31.5786 13.1716 30.8284C12.4214 30.0783 12 29.0609 12 28C12 26.9391 12.4214 25.9217 13.1716 25.1716C13.9217 24.4214 14.9391 24 16 24H32"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
